export declare const server: (serv: Server, options: Options) => void;
export declare const player: (player: Player, serv: Server, settings: Options) => Promise<void>;
declare global {
    interface Server {
    }
    interface Player {
        /** The username of the player */
        username: string;
        /** set player gameMode to `gameMode` */
        "setGameMode": (gameMode: any) => void;
        /** login */
        "login": () => Promise<void>;
    }
}
